<h1 mat-dialog-title>Select module to add</h1>
<div mat-dialog-content>
  <div class="add-dialog-content">
    <mat-card *ngFor="let moduleAbstract of moduleAbstracts" (click)="addModuleInstance(moduleAbstract)">
      <i class="material-icons large md-inactive">{{moduleAbstract.icon}}</i>
      <p>{{moduleAbstract.abstractName}}</p>
    </mat-card>
  </div>
</div>
